import config from "@/lib/config";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import routes from "@/lib/routes";

const footer = {
  vod: `
･････････････････････････････････････････････････････････
□このメールアドレスは、配信専用です。
  本メールに返信をいただきましても、ご質問等にはお答えできませんのでご了承ください。

□お問い合わせフォーム
  https://spoox.skyperfectv.co.jp/inquiry

□配信元
  スカパーJSAT株式会社　東京都港区赤坂1-8-1

□スカパー！動画ストア公式サイト
  https://spoox.skyperfectv.co.jp/
･･････････････････････････････････････････････････････････････････････････････････････
`,
};

export function profilePinResetTokenMail({ address, token }) {
  const maxAge = config.pincode.maxAge / 60;
  const url = `${config.host.vod}${routes.profilePincodeReset}?token=${token}`;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
暗証番号リセットを受付いたしました。
以下URLよりお手続きをお願いいたします。

${url}

URLが発行されてから${maxAge}分以内に登録を完了してください。
URLが無効になった場合は、お手数ですが再度メールアドレスの登録を行ってください。

${footer.vod}
  `,
  };
  return {
    address,
    subject: "暗証番号リセットのお知らせ",
    body: body["vod"],
  };
}

export function passwordResetTokenMail({ address, token }) {
  const maxAge = config.pincode.maxAge / 60;
  const url = `${config.host.vod}${routes.passwordRemindReset}?token=${token}`;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
パスワードリセットを受付いたしました。
以下URLよりお手続きをお願いいたします。

${url}

URLが発行されてから${maxAge}分以内に登録を完了してください。
URLが無効になった場合は、お手数ですが再度メールアドレスの登録を行ってください。

${footer.vod}
  `,
  };
  return {
    address,
    subject: "パスワードリセット方法のお知らせ",
    body: body["vod"],
  };
}

export function passwordResetComplete({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
パスワードリセットが完了いたしました。
ご登録いただいたパスワードでログインしてお楽しみください。

${config.host.vod}${routes.login}

${footer.vod}
  `,
  };
  return {
    address,
    subject: "パスワードリセット完了のお知らせ",
    body: body["vod"],
  };
}

export function passwordUpdateComplete({ address }) {
  const body = {
    vod: `
    パスワード変更が完了いたしました。
    ご登録いただいたパスワードでログインしてお楽しみください。
    ログイン
    ${config.host.vod}${routes.login}

${footer.vod}
  `,
  };
  return {
    address,
    subject: "パスワード変更完了のお知らせ",
    body: body["vod"],
  };
}

export function duplicateAddress({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
お客様のメールアドレスで会員登録がございました。
お客様は既にご登録済みとなりますのでログイン画面よりログインしてご利用ください。
ログイン
${config.host.vod}${routes.login}

新たに会員登録を希望の場合は、別のメールアドレスにて再度会員登録をお願い致します。

心当たりが無い場合、よくある質問（https://faq.skyperfectv.co.jp/?site_domain=spoox）をご確認いただき、入力いただいたメールアドレスについてご確認をお願いいたします。

${footer.vod}
    `,
  };
  return {
    address,
    subject: "メールアドレス認証のお知らせ",
    body: body["vod"],
  };
}

export function accountEditDuplicateAddress({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
会員情報変更でお客様のメールアドレスが入力されました。
心当たりがない場合は不正アクセスのおそれがありますので、メールアドレスやパスワードの変更をお願い致します。

${footer.vod}
    `,
  };
  return {
    address,
    subject: "メールアドレス認証のお知らせ",
    body: body["vod"],
  };
}

export function signupComplete({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
本メールは、${serviceName}の利用登録されたお客様へお送りしています。
この度は${serviceName}の利用登録いただきありがとうございます。
利用登録が完了いたしました。

※ご登録いただいた会員情報の確認・変更はスカパー！メンバーズサイトにてご確認ください。


${footer.vod}
    `,
  };
  return {
    address,
    subject: "利用登録完了のお知らせ",
    body: body["vod"],
  };
}

export function userUpdate({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
お客様情報の変更が完了いたしました。
変更後の情報はアカウントページよりご確認いただけます。


${footer.vod}
    `,
  };
  return {
    address,
    subject: "ご登録情報変更のお知らせ",
    body: body["vod"],
  };
}

export function withdrawalComplete({ address }) {
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
${serviceName}の利用登録解除の手続きが完了いたしました。
スカパー！メンバーズIDの削除をご希望の場合はスカパー！メンバーズサイトよりお手続きをお願いいたします。
またのご利用、心よりお待ちしております。

${footer.vod}
    `,
  };
  return {
    address,
    subject: "スカパー！動画ストアの利用登録解除のお知らせ",
    body: body["vod"],
  };
}

export function addPaymentInstrument({ address, paymentInstrument }) {
  const paymentMethod = paymentInstrument.payment_method;
  const body = (() => {
    if (paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS) {
      const cardNumber = `****-****-****-${paymentInstrument?.values?.card_number}`;
      return `
お支払い情報の登録が完了いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}
クレジットカード番号: ${cardNumber}

${footer["vod"]}
`;
    } else {
      return `
お支払い情報の登録が完了いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}

${footer["vod"]}
`;
    }
  })();

  return {
    address,
    subject: "お支払い情報の登録が完了しました",
    body: body,
  };
}

export function changePaymentInstrument({
  address,
  course,
  paymentInstrument,
}) {
  const paymentMethod = paymentInstrument.payment_method;
  const body = (() => {
    if (
      paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS ||
      paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS
    ) {
      const cardNumber = `****-****-****-${paymentInstrument?.values?.card_number}`;
      return `
${course.name}のお支払い情報を変更いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}
クレジットカード番号: ${cardNumber}

${footer["vod"]}
`;
    } else {
      return `
${course.name}のお支払い情報を変更いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}

${footer["vod"]}
`;
    }
  })();

  return {
    address,
    subject: "お支払い情報の変更が完了しました",
    body: body,
  };
}

export function inquiry({
  name,
  address,
  membersId,
  pastSpooxId,
  subject,
  body,
  comment,
}) {
  const env = process.env.APP_ENV || process.env.NODE_ENV || "development";
  const mailSubject =
    env !== "production" ? `[${env}環境] ${subject}` : subject;
  const mailBody = {
    vod: `
ご連絡可能なメールアドレス： ${address}
お名前： ${name}
スカパー！メンバーズID： ${membersId}
過去ご登録の旧SPOOX ID： ${pastSpooxId}
お問い合わせ内容： ${subject}
お問い合わせ内容詳細： ${body}

${comment}
    `,
  };
  return {
    address: config.inquiryMailAddress,
    subject: mailSubject,
    body: mailBody["vod"],
  };
}
